import { render } from "./communityQuiz.vue?vue&type=template&id=565adaa2&scoped=true"
import script from "./communityQuiz.vue?vue&type=script&lang=js"
export * from "./communityQuiz.vue?vue&type=script&lang=js"

import "./communityQuiz.vue?vue&type=style&index=0&id=565adaa2&lang=css"
import "./communityQuiz.vue?vue&type=style&index=1&id=565adaa2&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565adaa2"]])

export default __exports__